import * as MsDyn365 from '@msdyn365-commerce/core';

export const addParamsToLinkUrl = (link: MsDyn365.ILinkData, params: Record<'name' | 'value', string>[] = []): MsDyn365.ILinkData => {
    if (!link?.destinationUrl || params.length === 0 || !MsDyn365.msdyn365Commerce.isBrowser) {
        return link;
    }

    try {
        const url = new URL(link.destinationUrl, window.location.href);

        params.forEach(param => {
            url.searchParams.set(param.name, param.value);
        });

        return { ...link, destinationUrl: url.toString() };
    } catch (error) {
        console.error('Failed to modify link URL:', error);
        return link;
    }
};
